import React, { useCallback } from "react";
import { Form } from "reactstrap";

import { Dispatch } from "../types";
import { ResetButton } from "./ResetButton";
import { SaveButton } from "./SaveButton";
import { ShowReadingOrderToggle } from "./ShowReadingOrderToggle";
import { SubmitButton } from "./SubmitButton";

import "./styles.scss";

type Props = Readonly<{
  disabled: boolean;
  dispatch: Dispatch;
  showReadingOrder: boolean;
  onReset: () => void;
  onSave: () => void;
  onSubmit: () => void;
}>;

const SUBMIT_DIALOG = "Are you sure you want to submit this job?";

export const Menu = ({
  disabled,
  dispatch,
  onReset,
  onSave,
  onSubmit,
  showReadingOrder,
}: Props) => {
  const toggleShowReadingOrder = useCallback(() => {
    dispatch({
      type: "TOGGLE SHOW READING ORDER",
    });
  }, [dispatch]);
  const onFormSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (!disabled) {
        if (window.confirm(SUBMIT_DIALOG)) {
          onSubmit();
        }
      }
    },
    [disabled, onSubmit],
  );
  return (
    <Form className="menu" onSubmit={onFormSubmit}>
      <ShowReadingOrderToggle
        checked={showReadingOrder}
        disabled={false}
        onChange={toggleShowReadingOrder}
      />
      <div className="ml-auto">
        <ResetButton disabled={disabled} onClick={onReset} />
        <SaveButton disabled={disabled} onClick={onSave} />
        <SubmitButton disabled={disabled} />
      </div>
    </Form>
  );
};
Menu.displayName = "Menu";
